import {
  TELECONSULTORIA_GUEST_ALREADY_INVITED,
  TELECONSULTORIA_INVITE_PENDING,
} from "../../constants";
import { InviteActionError } from "../services/inviteActionError";

/** Mensagens que já vêm prontas para o usuário (regras do convite). */
const USER_FACING_MESSAGES = new Set([
  TELECONSULTORIA_GUEST_ALREADY_INVITED,
  TELECONSULTORIA_INVITE_PENDING,
]);

/** Regra de negócio mostra a própria mensagem; erro técnico vira o texto genérico. */
export function inviteErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof InviteActionError) return error.message;
  if (error instanceof Error && USER_FACING_MESSAGES.has(error.message)) {
    return error.message;
  }
  return fallback;
}
